import { SettingsEnum } from '@/modules/featureFlags/domain/models/AllFlagsDTO'

import { ConfigurationTypes } from '../../../types/clinic/configurations/configuration-types'
import { axios, Response } from '../index'

export interface GetConfigurationsResponse {
  id: string
  typeSettings: ConfigurationTypes
  title: string
  description: string
  isCheck: boolean
  settingEnum: SettingsEnum
}

const getConfigurations = (): Response<GetConfigurationsResponse[]> => {
  return axios.get(`/v1/settings`)
}

export default getConfigurations
